<template>
  <div>
    <div class="banner">
      <img src="../assets/banner4.png" alt="" />
    </div>
    <!-- <p class="text1">尊敬的来宾，您好！</p> -->
    <p class="text">
      出国留学需要基于学生的基本情况做精准评估，为了更好地帮学生推荐适合的国家和学校，希望您提供孩子的申请背景，我们根据孩子的情况帮您预约适合的顾问老师进行一对一回访咨询，高效准确的给到您申请建议，谢谢您的理解和配合！
    </p>
    <div class="home">
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="学生姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入您的姓名" />
        </el-form-item>
        <el-form-item label="学生性别" prop="sex">
          <el-radio v-model="form.sex" label="男">男</el-radio>
          <el-radio v-model="form.sex" label="女">女</el-radio>
        </el-form-item>

        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入您的手机号码" />
        </el-form-item>
        <el-form-item label="通过何种渠道了解看世界" prop="channel">
          <el-select
            v-model="form.channel"
            multiple
            placeholder="请选择了解的渠道"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="在读/毕业院校（大学/大专/高中/中小学）"
          prop="school"
        >
          <el-input
            v-model="form.school"
            placeholder="请输入您的在读/毕业院校"
          />
        </el-form-item>
        <el-form-item label="在读年级" prop="grade">
          <el-input v-model="form.grade" placeholder="请输入您的在读年级" />
        </el-form-item>
        <el-form-item label="在读专业（大学专业/高中选科）" prop="major">
          <el-input v-model="form.major" placeholder="请输入您的在读专业" />
        </el-form-item>
        <el-form-item
          label="在校成绩（本科均分/GPA绩点/高中成绩）"
          prop="performance"
        >
          <el-input
            v-model="form.performance"
            placeholder="请输入您的在校成绩"
          />
        </el-form-item>
        <el-form-item
          label="外语成绩（雅思托福/四六级/雅思/小语种/高中英语成绩）"
          prop="foreignPerformance"
        >
          <el-input
            v-model="form.foreignPerformance"
            placeholder="请输入您的外语成绩"
          />
        </el-form-item>
        <el-form-item label="意向国家" prop="country">
          <el-input v-model="form.country" placeholder="请输入您的意向国家" />
        </el-form-item>
        <el-form-item
          label="是否已咨询过看世界留学顾问老师"
          prop="consultStatus"
        >
          <el-radio
            v-model="form.consultStatus"
            @input="input"
            label="已经咨询顾问老师"
            >已经咨询顾问老师</el-radio
          >
          <el-input
            v-if="this.id == '已经咨询顾问老师'"
            v-model="form.descript"
            placeholder="请输入您咨询过的老师"
          />

          <el-radio
            v-model="form.consultStatus"
            @input="input"
            label="首次咨询看世界留学事宜"
            >首次咨询看世界留学事宜</el-radio
          >
        </el-form-item>
        <el-form-item label="其他想要了解的内容" prop="other">
          <el-input
            v-model="form.other"
            placeholder="请输入您的其他想要了解的内容"
          />
        </el-form-item>
        <div class="bottom">给教育更多选择 给人生更多机会</div>

        <el-form-item>
          <div class="onSubmit">
            <el-button type="primary" @click="onSubmit('form')"
              >立即提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Message } from "element-ui";
export default {
  name: "HomeView",
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      id: "",
      options: [
        {
          value: "微信群",
          label: "微信群",
        },
        {
          value: "微信公众号",
          label: "微信公众号",
        },
        {
          value: "抖音号",
          label: "抖音号",
        },
        {
          value: "微信视频号",
          label: "微信视频号",
        },
        {
          value: "小红书",
          label: "小红书",
        },
        {
          value: "亲朋推荐",
          label: "亲朋推荐",
        },
        {
          value: "看世界在读学员",
          label: "看世界在读学员",
        },
        {
          value: "看世界老师推荐",
          label: "看世界老师推荐",
        },
        {
          value: "其它",
          label: "其它",
        },
      ],
      value1: [],
      // 表单参数
      form: {
        name: null,
        phone: null,
        sex: null,
        channel: null,
        school: null,
        grade: null,
        major: null,
        performance: null,
        foreignPerformance: null,
        country: null,
        consultStatus: null,
        descript: null,
        other: null,
      },
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: "请输入您的姓名",
            trigger: "blur",
          },
        ],
        channel: [
          {
            required: true,
            message: "请至少选择一种",
            trigger: "blur",
          },
        ],
        school: [
          {
            required: true,
            message: "请输入您的在读/毕业院校",
            trigger: "blur",
          },
        ],
        grade: [
          {
            required: true,
            message: "请输入您的在读年级",
            trigger: "blur",
          },
        ],
        major: [
          {
            required: true,
            message: "请输入您的在读专业",
            trigger: "blur",
          },
        ],
        performance: [
          {
            required: true,
            message: "请输入您的在校成绩",
            trigger: "blur",
          },
        ],
        foreignPerformance: [
          {
            required: true,
            message: "请输入您的外语成绩",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "请输入您的意向国家",
            trigger: "blur",
          },
        ],
        consultStatus: [
          {
            required: true,
            message: "请选择是否已咨询过看世界留学顾问老师",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入您的手机号码",
            trigger: "blur",
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "请输入正确的手机号",
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  methods: {
    input(e) {
      console.log(e, "wwwwwwwwwww");
      this.id = e;
    },
    onSubmit() {
      const that = this;

      this.$refs["form"].validate((valid) => {
        if (valid) {
          // ksjoa.cn:444
          axios
            .post("https://ksjoa.cn:9445/system/question5", this.form)
            .then(function (response) {
              console.log(response, "9999999999999");
              console.log(response.data.code, "6666666");
              // Message.success("操作成功");
              // http://ksjoa.cn:444
              if (response.data.code == 200) {
                that.$router.push({ path: "/succeed" });
              } else {
                Message.success(response.data.msg);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
          this.$refs.form.resetFields();
          this.form.descript == null;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.banner {
  width: 100%;
  img {
    width: 100%;
  }
}
.text {
  text-align: center;
  font-size: 13.5px;
}
.text1 {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  margin: 10px 0;
}
.bottom {
  margin: 20px 0;
}
.home {
  margin: 15px;
  .el-form-item {
    text-align: left;
  }
  .son {
    margin-left: 30px;
  }
}
.onSubmit {
  text-align: center;
}
</style>